var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "auth-return" },
    [
      _c("popup", {
        attrs: {
          opened: _vm.openData,
          title: _vm.popupGbn === 1 ? "MMENU-0059" : "MMENU-0052"
        },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: function() {
            _vm.menuOpen = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _vm.popupGbn === 1
                  ? _c(
                      "article",
                      { staticClass: "contents" },
                      [
                        _vm.isLogin && _vm.isPersonalUser
                          ? _c("article", [
                              _c("div", { staticClass: "cont-tit" }, [
                                _c("h6", [
                                  _vm._v(
                                    _vm._s(
                                      /*로그인 설정*/ _vm.$t("MLGI-07-01-02-02")
                                    )
                                  )
                                ])
                              ]),
                              _c("ul", { staticClass: "pop-menu-list" }, [
                                _c("li", { staticClass: "pop-menu-item" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        /*간편 인증 번호*/ _vm.$t(
                                          "MLGI-07-01-02-03"
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c("div", { staticClass: "form-switch" }, [
                                    _c("input", {
                                      staticClass: "form-check-input",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.$store.state.auth.createFido
                                            .isPincode === "0"
                                            ? false
                                            : true
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.FN001_MenuPopup($event)
                                        }
                                      }
                                    }),
                                    _c("span", { staticClass: "slider round" })
                                  ])
                                ]),
                                _c("li", { staticClass: "pop-menu-item" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$store.state.native
                                          .biometryTypeIos === "faceId"
                                          ? _vm.$t("MLGI-07-01-02-05")
                                          : _vm.$t("MLGI-07-01-02-04")
                                      ) +
                                      " "
                                  ),
                                  _c("div", { staticClass: "form-switch" }, [
                                    _c("input", {
                                      staticClass: "form-check-input",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.$store.state.auth.createFido
                                            .isFingerprint === "0"
                                            ? false
                                            : true
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.FN002_MenuPopup($event)
                                        }
                                      }
                                    }),
                                    _c("span", { staticClass: "slider round" })
                                  ])
                                ]),
                                _vm.$store.state.auth.createFido
                                  .isFingerprint !== "0" &&
                                _vm.$store.state.auth.createFido.svrFidoInfo.out
                                  .success.isSimple
                                  ? _c("li", { staticClass: "pop-menu-item" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$store.state.native
                                              .biometryTypeIos === "faceId"
                                              ? /* Face ID 이체 사용 */ _vm.$t(
                                                  "FIDO-0015"
                                                )
                                              : /* 지문 이체 사용 */ _vm.$t(
                                                  "MLGI-07-01-02-06"
                                                )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-switch" },
                                        [
                                          _c("input", {
                                            staticClass: "form-check-input",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked:
                                                _vm.$store.state.auth.createFido
                                                  .svrFidoInfo.out.success
                                                  .fidoInfo.fngprUseYn === "1"
                                                  ? true
                                                  : false
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.FN003_MenuPopup(
                                                  $event
                                                )
                                              }
                                            }
                                          }),
                                          _c("span", {
                                            staticClass: "slider round"
                                          })
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e(),
                        _vm._l(_vm.selectMenu.children, function(m, i) {
                          return _c("div", { key: i }, [
                            _c("div", { staticClass: "cont-tit" }, [
                              _c("h6", [_vm._v(_vm._s(_vm.$t(m.title)))])
                            ]),
                            _c(
                              "ul",
                              { staticClass: "pop-menu-list" },
                              _vm._l(m.children, function(submenu, j) {
                                return _c(
                                  "li",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !(
                                          (submenu.name ==
                                            "serviceCancelStep1" &&
                                            _vm.isCorporationSubUser) ||
                                          (submenu.name == "changePassword" &&
                                            _vm.isCorporationSubUser) ||
                                          (submenu.name == "motpTest" &&
                                            "production|staging".includes(
                                              _vm.env
                                            ))
                                        ),
                                        expression:
                                          "\n                !(\n                  (submenu.name == 'serviceCancelStep1' && isCorporationSubUser) ||\n                  (submenu.name == 'changePassword' && isCorporationSubUser) ||\n                  (submenu.name == 'motpTest' && 'production|staging'.includes(env))\n                )\n              "
                                      }
                                    ],
                                    key: j,
                                    staticClass: "pop-menu-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.goPage(submenu)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t(submenu.title)) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "icon icon-sm-right-arrow"
                                    })
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        }),
                        _vm.isLogin &&
                        "NAPASVN1|NAPASVN2|NAPASVN11|NAPASVN12|NAPASVN21|NAPASVN22|PTHAO1101|TUANHAIBAC|QDUNGTB93|DUYHUYNH87".includes(
                          _vm.sessionInfo.userInfo.userIdnfr
                        ) &&
                        "production|staging".includes(_vm.env)
                          ? [
                              _c("div", { staticClass: "cont-tit" }, [
                                _c("h6", [_vm._v("TEST MENU")])
                              ]),
                              _c("ul", { staticClass: "pop-menu-list" }, [
                                _c(
                                  "li",
                                  {
                                    staticClass: "pop-menu-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.goNapas()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" NapasTest "),
                                    _c("i", {
                                      staticClass: "icon icon-sm-right-arrow"
                                    })
                                  ]
                                )
                              ])
                            ]
                          : _vm.isLogin &&
                            "TESTID008|TESID001".includes(
                              _vm.sessionInfo.userInfo.userIdnfr
                            )
                          ? [
                              _c("div", { staticClass: "cont-tit" }, [
                                _c("h6", [_vm._v("TEST MENU")])
                              ]),
                              _c("ul", { staticClass: "pop-menu-list" }, [
                                _c(
                                  "li",
                                  {
                                    staticClass: "pop-menu-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.goCbmnet()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" CBM-NET2 "),
                                    _c("i", {
                                      staticClass: "icon icon-sm-right-arrow"
                                    })
                                  ]
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm.popupGbn === 2
                  ? _c("article", { staticClass: "contents" }, [
                      _c(
                        "ul",
                        { staticClass: "pop-menu-list" },
                        _vm._l(_vm.selectMenu.children, function(m, i) {
                          return _c(
                            "li",
                            {
                              key: i,
                              staticClass: "pop-menu-item",
                              on: {
                                click: function($event) {
                                  return _vm.goPage(m)
                                }
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.$t(m.title)) + " "),
                              _c("i", {
                                staticClass: "icon icon-sm-right-arrow"
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("FidoPopup")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }